module.exports = __webpack_public_path__ + "img/2.ecde4c85.jpg";